import { useLocation } from 'react-router-dom';
import { createRoutingService } from './RoutingService.impl';

export const myRoutingService = createRoutingService({
  use: () => useLocation().pathname,
  get: () => window.location.pathname
});
